module.exports = __webpack_public_path__ + "img/front.e8a7cdc3.png";